module.exports = __webpack_public_path__ + "static/img/string_banner.5f3bd2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/string_banner.png
// module id = T+bx
// module chunks = 1